import contextCreator from "../contextCreator";
import AhliCalculatorReducer, { initialState } from "./ahliCalculator.reducer";

// eslint-disable-next-line react-hooks/rules-of-hooks
const [state, dispatch, provider] = contextCreator(
  AhliCalculatorReducer,
  initialState
);

export const useAhliCalculatorState = state;
export const useAhliCalculatorDispatch = dispatch;
export const AhliCalculatorProvider = provider;
